module.exports = __webpack_public_path__ + "static/thrive-digital-logo-de0cdc762ad1fcf8832b531446c98232.png";